import Vue from "vue";
import base from "./baseCore";

export default Object.assign(
    {
        apiUrl: "/public",

        async privacy() {
            return Vue.http.get(this.url(`/privacy`));
        },

        async userterms() {
            return Vue.http.get(this.url(`/useterms`));
        }
    },
    base
);
